import { Stack, Typography } from '@mui/material';
import { HomePageSidebarIntegrationsList } from './home-page-sidebar-integrations-list/HomePageSidebarIntegrationsList';

export const HomePageSidebarIntegrations: React.FC = () => {
  return (
    <Stack 
      gap={4}
      sx={{
        padding: 2,
      }}
    >
      <Typography variant='h6'>Integrations</Typography>
      <HomePageSidebarIntegrationsList/>
    </Stack>
  );
};